module.exports = "<div *ngIf=\"loaded\">\n  <app-nav-menu></app-nav-menu>\n  <div class=\"container\">\n    <router-outlet></router-outlet>\n  </div>\n</div>\n<div *ngIf=\"!loaded\" style=\"position: absolute; left: 50%; top: 50%;\">\n  Loading\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main